var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-card"},[_c('div',{staticClass:"overview-card--heading"},[_c('p',[_vm._v(_vm._s(_vm.totalCustomersToPay)+" Customers Meant To Pay This Week 🚨")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.openTracker}},[_vm._v(" Open Payment Tracker "),_c('i',{staticClass:"el-icon-arrow-right"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }